import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentSpaceCluster on Cluster {
    id
    name
    code
    description
    assignedSpaceIds
    organization
    comment
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentSpaceClusterFragment,
  ents.extra.space.Cluster
>({
  assignedSpaceIds: graphql.transformers.OUT.default(
    graphql.transformers.OUT.list(
      graphql.transformers.OUT.validate(
        transformers.PASS_THROUGH,
        ents.extra.space.Record.Id.isId,
      ),
      { onNullish: 'remove' },
    ),
    [],
  ),
  code: transformers.PASS_THROUGH,
  comment: transformers.PASS_THROUGH,
  description: transformers.PASS_THROUGH,
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.space.Cluster.Id.isId,
  ),
  name: transformers.PASS_THROUGH,
  organization: graphql.transformers.OUT.validate(
    graphql.transformers.OUT.json(),
    ents.extra.space.Organization.Lookup.assertIsLookup,
  ),
})
